import lodash from 'lodash'
import { FilterCondition, FilterField, Op } from '../types'

export const checkOp = (scope: any, prop: string, op: Op, to: any): boolean => {
  const value = lodash.get(scope, prop)

  switch (op) {
    case 'neq':
      return !lodash.isEqual(value, to)
    case 'gt':
      return value > to
    case 'lt':
      return value < to
    case 'gte':
      return value >= to
    case 'lte':
      return value <= to
    case 'in':
      return checkIn(to, value)
    case 'nin':
      return !checkIn(to, value)
    case 'ends-with':
      return (value + '').endsWith(to)
    case 'starts-with':
      return (value + '').startsWith(to)
    case 'contains':
      return checkContains(value, to)
    case 'eq':
    default:
      return lodash.isEqual(value, to)
  }
}

const checkIn = (collection: any, value: any): boolean => {
  if (Array.isArray(collection)) {
    return collection.some((v) => lodash.isEqual(value, v))
  }
  return collection.includes?.(value) ?? false
}

const checkContains = (haystack: any, needle: any): boolean => {
  if (lodash.isNil(haystack)) return false

  if (Array.isArray(haystack)) {
    if (Array.isArray(needle)) {
      return needle.every((n) => haystack.some((h) => lodash.isEqual(h, n)))
    }
    return haystack.some((h) => lodash.isEqual(h, needle))
  }

  const haystackStr = lodash.toString(haystack)
  if (Array.isArray(needle)) {
    return needle.every((n) => haystackStr.includes(lodash.toString(n)))
  }
  return haystackStr.includes(lodash.toString(needle))
}

export const opToSymbol = (op: Op): string => {
  switch (op) {
    case 'neq':
      return '!='
    case 'gt':
      return '>'
    case 'lt':
      return '<'
    case 'gte':
      return '>='
    case 'lte':
      return '<='
    case 'in':
      return 'in list'
    case 'nin':
      return 'not in list'
    case 'ends-with':
      return 'ends with'
    case 'starts-with':
      return 'starts with'
    case 'contains':
      return 'contains'
    case 'eq':
    default:
      return '=='
  }
}

export const createDefaultCondition = (field: FilterField, op: Op): FilterCondition => {
  return { path: field.path, op, value: '' }
}
